import { useTheme } from '@mui/material';
import { useGetRouteToIssuerPage } from '../../../../app/get-route-to-page';
import { Page } from '../../../../app/page-url-path';
import { useGetTheme } from '../../../../hooks/use-get-theme';
import { useSettingBasedOnBreakpoints } from '../../../../hooks/use-setting-based-on-breakpoints';
import { useGetIssuerShortname } from '../../../../hooks/use-get-issuer-shortname';
import { getCompanyLogo } from './get-company-logo';

const useHeaderWithLogoOnly = () => {
  const theme = useGetTheme();
  const muiTheme = useTheme();
  const {
    isDesktop, isTablet, isTabletMini, isMobile,
  } =
    useSettingBasedOnBreakpoints(muiTheme);
  const shortname = useGetIssuerShortname() ?? '';

  const companyLogo = getCompanyLogo(shortname);
  const homepagePath = useGetRouteToIssuerPage(Page.HOMEPAGE);

  return {
    theme,
    muiTheme,
    isDesktop,
    isTablet,
    isTabletMini,
    isMobile,
    companyLogo,
    homepagePath,
  };
};

export default useHeaderWithLogoOnly;
